import { defineElement, BaseElement } from '@webtides/element-js';
import SpecFilterEvents from '../../structures/_category-page/spec-filter/SpecFilterEvents.js';
import SpecChipEvents from '../../structures/_category-page/spec-chip/SpecChipEvents';

import FlyoutElementEvent from '../../elements/flyout-element/FlyoutElementEvent';
import FrameSelectorEvent from '../../structures/frame-selector/FrameSelectorEvent';
import DropDownEvents from '../../structures/_category-page/dropdown-sort/DropDownSortEvents';
//dependencies
import '../../structures/_category-page/filter-meta/filter-meta';
import '../../structures/_product/product-list/product-list';
import '../../../legacy-library/webcomponents/svg-icon/svg-icon';
import qs from 'qs/dist/qs';
import PagingElementEvents from '../../elements/paging-element/paging-element-events';

class CategoryPage extends BaseElement {
    properties() {
        return {
            filter: [],
            filterUrl: '',
            frameFilter: {},
            products: [],
            productUrl: '',
            total: 0,
            manualScroll: true,
            defaultSort: 'RELEVANCE',
            query: '',
            xhrGetPassthrough: {},
            meta: {},
        };
    }

    constructor() {
        super();
        this._filterChangeSinceLoad = true;
    }

    async connected() {
        if (this.manualScroll && window.history.scrollRestoration) {
            window.history.scrollRestoration = 'manual';
        }
        //
        if (!this.filter || this.filter.length === 0) {
            const search = location.search.replace('?', '');
            const urlParams = qs.parse(search);
            await this.loadFilter(false, urlParams);
        }

        if (this.products.length === 0) {
            await this.reloadProducts();
        }

        this.applyFilter();

        this.$refs.productList.products = this.products;
        //
        if (this.$refs.mainFrameSelector && this.frameFilter) {
            this.$refs.mainFrameSelector.frames = this.frameFilter.values.map(frame => frame.key);
            const activeFrame = this.frameFilter.values.find(val => val.selected);
            if (activeFrame) {
                this.$refs.mainFrameSelector.activeFrame = activeFrame.key;
                this.$refs.productList.activeFrame = activeFrame.key;
            }
        }

        const activeColor = this.getActiveColorFilter();
        if (activeColor) {
            this.$refs.productList.activeColorKey = activeColor;
        }

        //async mode structured data. No clue if this makes sense at all but its worth to give it a try
        const listSnippet = document.querySelector('item-list-snippet');
        if (listSnippet) {
            listSnippet.products = this.products;
        }
        // enable paging
    }

    watch() {
        return {
            products: () => {
                this.$refs.productList.products = this.products;
            },
            total: () => {
                this.querySelectorAll('product-count').forEach($productCount => {
                    $productCount.count = this.total;
                });
            },
            query: () => {
                // flag to relaod pocucts due to filter change
                this._filterChangeSinceLoad = true;
            },
            filter: () => this.applyFilter(),
        };
    }

    // TODO move to store
    get hasSelectedFilters() {
        const filterSelected = this.filter?.some(filter => filter?.values?.some(value => value.selected));
        const frameFilterSelected = this.frameFilter?.values?.some(value => value.selected);

        return filterSelected || frameFilterSelected;
    }

    updateProductList(loading = false) {
        this.classList.toggle('is-loading', loading);

        this.classList.toggle('is-empty', !loading && this.products.length === 0);
        this.classList.toggle('has-selected-filter', !loading && this.hasSelectedFilters);

        if (!loading) {
            const activeColor = this.getActiveColorFilter();
            this.$refs.productList.activeColorKey = activeColor || false;
            const frame = this.$refs.mainFrameSelector?.activeFrame ?? 'ALL';
            this.$refs.productList.activeFrame = frame;
        }

        if (this.$refs.paging && this.meta.paged) {
            this.$refs.paging.disabled = false;
            this.$refs.paging.pages = this.meta.pages;
            this.$refs.paging.currentPage = this.meta.page;
            this.$refs.paging.total = this.total;
        }
    }

    getTempFilter() {
        // TODO Rename .. .temp is weired .. better from DOM or UI ot sth
        const tempFilter = Array.from(this.filter);

        this.querySelectorAll('[filter]').forEach(filterElement => {
            const filterObject = { key: filterElement.key, values: filterElement.values };
            const filterIndex = tempFilter.findIndex(filter => filter.key === filterObject.key);

            Object.assign(tempFilter[filterIndex], filterObject);
        });
        return tempFilter;
    }

    removeFilter({ key, index }) {
        const tempFilter = Array.from(this.filter);
        if (parseInt(index) === -1) {
            //unselect all filters
            tempFilter.forEach(filter => {
                filter.values.forEach(value => {
                    value.selected = false;
                });
            });
            const tempFrameFilter = Object.assign({}, this.frameFilter);
            tempFrameFilter.values.forEach((value, index) => (value.selected = false));
            this.frameFilter = tempFrameFilter;

            if (this.$refs.mainFrameSelector) {
                this.$refs.mainFrameSelector.activeFrame = this.$refs.mainFrameSelector.showAllFrames ? 'ALL' : '';
            }
        } else {
            const filterIndex = tempFilter.findIndex(filter => filter.key === key);
            if (filterIndex > -1) {
                tempFilter[filterIndex].values[index].selected = false;
            } else {
                // must be frame filter
                this.frameFilter.values[index].selected = false;
                if (this.$refs.mainFrameSelector) {
                    this.$refs.mainFrameSelector.activeFrame = this.$refs.mainFrameSelector.showAllFrames ? 'ALL' : '';
                }
            }
        }

        this._filterChangeSinceLoad = true;
        this.loadFilter(tempFilter).then(() => this.reloadProducts());
    }

    events() {
        return {
            this: {
                [SpecFilterEvents.APPLY_SINGLE_FILTER]: ({ detail }) => {
                    const tempFilter = Array.from(this.filter);
                    const { key } = detail;
                    const filterIndex = tempFilter.findIndex(filter => filter.key === key);

                    Object.assign(tempFilter[filterIndex], detail);

                    this.loadFilter(tempFilter);
                },
                [SpecFilterEvents.FILTER_CHANGE]: () => {
                    const tempFilter = this.getTempFilter();
                    // just load enw filter state
                    if (this.$refs.paging) {
                        // reset paging
                        this.$refs.paging.currentPage = 0;
                    }
                    this.loadFilter(tempFilter);
                },
                [SpecFilterEvents.APPLY_FILTERS]: () => {
                    this.filter = this.getTempFilter();
                    this.applyFilter();
                    this.reloadProducts();
                },
                [SpecChipEvents.REMOVE_INDEX]: ({ detail }) => {
                    this.removeFilter(detail);
                },
                [FlyoutElementEvent.FLYOUT_CLOSED]: () => {
                    if (this.$refs.filter) {
                        //will trigger a product reload
                        this.$refs.filter.isOpen = false;
                    } else {
                        this.reloadProducts();
                    }
                },
                [PagingElementEvents.PAGE_CHANGE]: () => {
                    this._filterChangeSinceLoad = true;
                    this.reloadProducts();

                    this.scrollIntoView({ behavior: 'smooth' });
                },
                [SpecFilterEvents.OPEN_FILTER]: () => {
                    this.$refs.backdrop.open = true;
                },
            },
            '[main-frame-selector]': {
                [FrameSelectorEvent.FRAME_CLICK]: ({ detail }) => {
                    const tempFilter = Object.assign({}, this.frameFilter);
                    tempFilter.values.forEach(value => (value.selected = detail === value.key));
                    this.frameFilter = tempFilter;
                    this._filterChangeSinceLoad = true;

                    this.loadFilter().then(() => this.reloadProducts());
                },
            },
            '[toggle-filter]': {
                click: ev => {
                    ev.stopPropagation();

                    this.$refs.filterFlyout.toggle();
                    if (this.$refs.filter) {
                        this.$refs.filter.isOpen = true;
                    }
                },
            },
            '[ref=sort]': {
                [DropDownEvents.CHANGE_OPTION]: ev => {
                    //prolly mobile -> return and wait for cta
                    //TODO reset paging if paged !?
                    this._filterChangeSinceLoad = true;
                    if (this.$refs.filterFlyout.open) {
                        return;
                    }
                    this.reloadProducts();
                },
            },
            '[ref=reset]': {
                click: ev => {
                    ev.stopPropagation();
                    this.removeFilter({ index: -1, key: '' });
                },
            },
            window: {
                click: ev => {
                    const filterSpecs = this.$refs.filter;
                    const filterFlyout = this.$refs.filterFlyout;
                    const isMobile = filterFlyout.classList.contains('open');

                    // We can ignore this callback on mobile because the backdrop will emit a close event.
                    if (isMobile) {
                        return;
                    }

                    if (filterSpecs && filterSpecs.isOpen && !filterSpecs.contains(ev.target)) {
                        filterSpecs.isOpen = false;

                        this.$refs.backdrop.open = false;
                    }
                },
            },
        };
    }

    applyFilter() {
        if (!this.filter || !this.$refs.filter) {
            return;
        }
        this.querySelectorAll('filter-meta').forEach($meta => {
            $meta.filter = [];
            $meta.filter = [...this.filter, this.frameFilter];
        });

        this.$refs.filter.filter = [];
        this.$refs.filter.filter = [...this.filter];
        //
    }

    fetch(url, options) {
        const fetchOptions = Object.assign(
            {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: 'include',
            },
            options
        );
        return fetch(url, fetchOptions)
            .then(response => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response.json();
            })
            .then(response => {
                //set undefined to trigger redraws
                return response;
            });
    }

    getActiveColorFilter() {
        let key = '';
        const farf = this.filter.find(filter => filter.key === 'FARF');
        if (farf) {
            const selected = farf.values.find(value => value.selected);
            return selected ? selected.key : false;
        }
        return false;
    }

    getSelection(newFilter = false) {
        const values = {};
        const updatedFilter = newFilter || this.filter;

        updatedFilter.forEach(filter => {
            let selectedValues = [];
            if (filter.key === 'PRICE') {
                const minValue = filter.values.find(value => value.key === 'minValue');
                const maxValue = filter.values.find(value => value.key === 'maxValue');
                const { minRange, maxRange } = filter.meta;
                selectedValues.push(minValue.selected ? minValue.value : minRange);
                selectedValues.push(maxValue.selected ? maxValue.value : maxRange);
            } else {
                selectedValues = filter.values
                    .map(value => {
                        return value.selected ? value.key : null;
                    })
                    .filter(value => value !== null);
            }

            if (selectedValues.length > 0) {
                values[filter.key] = selectedValues;
            }
        });
        const filter = [...this.filter.map(filter => filter.key)];

        if (this.frameFilter && this.frameFilter.values) {
            const frame = this.frameFilter.values.find(val => val.selected);
            if (frame) {
                values[this.frameFilter.key] = frame.key;
            }
            filter.push(this.frameFilter.key);
        }
        if (this.$refs.sort) {
            values['sort'] = this.$refs.sort.value || this.defaultSort;
        }

        if (this.$refs.paging) {
            values['page'] = this.$refs.paging.currentPage;
        }

        return { values, filter };
    }

    loadFilter(newFilter = false, urlParameter = {}) {
        if (this._isLoadingFilter) {
            return;
        }

        this._isLoadingFilter = true;
        const { values, filter } = this.getSelection(newFilter);
        const body = {
            // always send all keys the active state is encapsulated in the the values
            filter,
            ...values,
            ...urlParameter,
            ...this.xhrGetPassthrough,
        };
        const query = qs.stringify(body, { arrayFormat: 'comma' });
        return this.fetch(`${this.filterUrl}?${query}`)
            .then(filters => {
                this._isLoadingFilter = false;
                this.filter = filters;
                this.applyFilter();
                //
                this.updateUrl(body);
            })
            .catch(() => {
                this._isLoadingFilter = false;
            });
    }

    reloadProducts() {
        if (!this._filterChangeSinceLoad) {
            this.$refs.backdrop.open = false;
            return;
        }
        this._filterChangeSinceLoad = false;

        const { values, filter } = this.getSelection();
        const body = {
            // always send all keys the active state is encapsulated in the the values
            filter,
            ...values,
            ...this.xhrGetPassthrough,
        };
        this.updateProductList(true);
        this.$refs.backdrop.open = false;
        // empty products to show loading spinner
        // this.products = [];
        const query = qs.stringify(body, { arrayFormat: 'comma' });
        return this.fetch(`${this.productUrl}?${query}`)
            .then(({ data, total, meta, paged }) => {
                this.products = data || [];
                this.total = total;
                this.meta = { paged, ...meta } || {};
                this.updateProductList();
                this.updateUrl(body);
                this.dispatch('PRODUCTS_CHANGED', this.products, true);
            })
            .catch(e => {
                console.log('could not load products', e);
                this.total = 0;
                this.updateProductList();
            });
    }

    updateUrl(body) {
        const searchParams = qs.parse(location.search?.substring(1) ?? '');
        const queryParams = { ...searchParams, ...body };
        Object.entries(this.xhrGetPassthrough).forEach(([key, value]) => {
            //strip passthrough parameters from url
            delete queryParams[key];
        });
        Object.entries(searchParams).forEach(([key, value]) => {
            //check if search param is known and delete if it´s not in current selection (body)
            if (body.filter.includes(key) && body.hasOwnProperty(key) === false) {
                // deselected known filter
                delete queryParams[key];
            }
        });

        this.query = qs.stringify(queryParams, { arrayFormat: 'comma' });
        history.replaceState(body, '', `?${this.query}`);
    }
}

defineElement('category-page', CategoryPage);
